import type { SidePanelProps } from '@wix/design-system';
import { SidePanel } from '@wix/design-system';
import classNames from 'classnames';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';

import classes from './panel-scss';

type Props = React.PropsWithChildren<SidePanelProps>;

export const Panel: React.FC<Props> = ({ children, dataHook, ...props }) => {
  const { isMobile, environment } = useContext(RicosContext);

  return (
    <SidePanel
      width={isMobile ? '100%' : 288}
      height={isMobile ? '100vh' : 'fit-content'}
      {...props}
      dataHook={classNames('floating-layout-root', dataHook)}
      skin="floating"
      className={classNames(classes.modal, { [classes.liveSite]: environment === 'liveSite' })}
    >
      {children}
    </SidePanel>
  );
};
